import { createIcon } from '../createIcon';
import { ReactComponent as IconGlobe } from '../svg/globe.svg';

export default createIcon(IconGlobe);
